import { render } from "./v-footer.vue?vue&type=template&id=6214fa91"
import script from "./v-footer.vue?vue&type=script&lang=js"
export * from "./v-footer.vue?vue&type=script&lang=js"

import "./v-footer.vue?vue&type=style&index=0&id=6214fa91&lang=css"
script.render = render

export default script